import { useEffect } from "react";
import { API_OPTIONS } from "../utils/constants"
import { useDispatch } from "react-redux";
import { addTrailerVideo } from "../utils/movieSlice";
import { setLoading } from "../utils/gptSlice";

const useTrailer = (movieId) =>{
    const dispatch = useDispatch();
    

    const getMovieVideos = async()=>{
    const data = await fetch("https://api.themoviedb.org/3/movie/"+movieId+"/videos?language=en-US",API_OPTIONS)
    const json = await data.json();

    const filterdData = json?.results?.filter((video)=> video.type === 'Trailer' );
    const trailer = filterdData.length ? filterdData[0]: json.results[0];
    dispatch(addTrailerVideo(trailer));
    dispatch(setLoading(false));
}
useEffect(()=>{
    getMovieVideos();
},[]);
}

export default useTrailer;
 
